import styled from '@emotion/styled';

const BookYourEventStyle = styled('div')`
    padding-top: 24px;
    margin-top: 48px;
    border-top: 1px solid var(--sand-400);

    .title-card {
        color: var(--sand-700);
        font-size: 24px;
        font-weight: 700;
        margin-bottom: 12px;
    }

    .why-book {
        font-size: 14px;
        .item {
            display: flex;
            align-items: flex-start;
            gap: 12px;
            padding: 6px 0;

            .icon-check {
                color: var(--orange-300);
                margin-top: 3px;
            }
        }
    }
`;
export default BookYourEventStyle;
